import * as Yup from 'yup';

const userSchema = Yup.object().shape({
  firstName: Yup.string().required('First Name is required.'),
  lastName: Yup.string().required('Last Name is required.'),
  countryCallingCode: Yup.string()
    .matches(/^\+\d{1,4}$/, 'Country Code must start with + followed by 1-4 digits')
    .required('Country Calling Code is required.'),
  mobileNumber: Yup.string()
    .matches(/^\d{6,15}$/, 'Mobile Number must be between 6-15 digits')
    .required('Mobile Number is required.'),
  email: Yup.string()
    .email('Invalid email format')
    .nullable(),
  userRole: Yup.string().required('User Role is required.'),
  // countryId: Yup.string().required('Country is required.'),
  // regionId: Yup.string().required('Region is required.'),
  // language: Yup.string().required('Language is required.'),
});

export default userSchema;